/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Motivation_QuestionInputs */

const en_us2_onboarding_motivation_question = /** @type {(inputs: Onboarding_Motivation_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What brought you here today? One sentence is enough.`)
};

const pt_br2_onboarding_motivation_question = /** @type {(inputs: Onboarding_Motivation_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que te trouxe aqui hoje? Uma frase já basta.`)
};

const es_419_onboarding_motivation_question = /** @type {(inputs: Onboarding_Motivation_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué te trajo aquí hoy? Una frase es suficiente.`)
};

const pt_pt2_onboarding_motivation_question = /** @type {(inputs: Onboarding_Motivation_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que te trouxe aqui hoje? Uma frase chega.`)
};

const fr_fr2_onboarding_motivation_question = /** @type {(inputs: Onboarding_Motivation_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu'est-ce qui t'amène ici aujourd'hui ? Une phrase suffit.`)
};

const de_de2_onboarding_motivation_question = /** @type {(inputs: Onboarding_Motivation_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was hat dich heute hergeführt? Ein Satz reicht.`)
};

const it_it2_onboarding_motivation_question = /** @type {(inputs: Onboarding_Motivation_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa ti ha portato qui oggi? Basta una frase.`)
};

/**
* | output |
* | --- |
* | "What brought you here today? One sentence is enough." |
*
* @param {Onboarding_Motivation_QuestionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_motivation_question = /** @type {((inputs?: Onboarding_Motivation_QuestionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Motivation_QuestionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_motivation_question(inputs)
	if (locale === "es-419") return es_419_onboarding_motivation_question(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_motivation_question(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_motivation_question(inputs)
	if (locale === "de-DE") return de_de2_onboarding_motivation_question(inputs)
	if (locale === "it-IT") return it_it2_onboarding_motivation_question(inputs)
	return en_us2_onboarding_motivation_question(inputs)
});
export { onboarding_motivation_question as "onboarding.motivation.question" }